import React, {  ReactElement, ReactFragment, ReactNode } from 'react'
import { Container, Box, Paper, Typography, Divider, Stack } from '@mui/material'
import { t } from 'i18next'
import { theme } from '../theme/maintheme'

type ILayoutProps = {
  title: string;
  titleExtraComponent?: ReactNode;
  children: ReactElement | ReactFragment | boolean | null | undefined;
}

const InsideLayout = (props: ILayoutProps) => {
  const {title, children, titleExtraComponent} = props
  return (
      <>
       <Container
      maxWidth={false}
      sx={{ padding: theme.spacing(2), height: "100%" }}
    >
      <Box sx={{ height: "100%" }}>
        <Paper
          elevation={1}
          sx={{
            height: "100%",
            position: "relative",
            borderRadius: "12px"
          }}
        >
         <Box  sx ={{ paddingTop: theme.spacing(2), paddingX: theme.spacing(3)}}>
              <header style={{ marginBottom: 15 }}>
                <Typography variant="h4">{t(title)}</Typography>
              </header>
              {titleExtraComponent ? titleExtraComponent : null}
           
          </Box>
          {/* <Divider per UX team request 
              sx={{ background: "#000", height: "1px",  opacity: 1}}
            /> */}
         <Box paddingX = { theme.spacing(2)}>
            {children}
         </Box>
        </Paper>
      </Box>
    </Container>
      </> 

)
}

export default InsideLayout